import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  item: {
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.grey[200],
    '&:first-child': {
      marginTop: 0,
    },
    '& $item': {
      border: `1px solid ${theme.palette.grey[400]}`,
      backgroundColor: theme.palette.common.white,
    },
  },
  addButton: {
    display: 'block',
    margin: `${theme.spacing(2)}px auto 0`,
    '&:first-child': {
      marginTop: 0,
    },
  },
  closeButton: {
    display: 'block',
    marginLeft: 'auto',
    fontSize: 12,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: `space-between`,
    padding: theme.spacing(0.5),
    backgroundColor: theme.palette.common.white,
  },
  list: {
    display: 'grid',
    gridTemplateColumns: `repeat(3, 1fr)`,
    gap: theme.spacing(2),
  },
}));
